import { useState, useEffect } from "react";
import WizardProgressBar from "./components/WizardProgressBar";
import ContactInformation from "./Steps/ContactInformation";
import BusinessProfileName from "./Steps/BusinessProfileName";
import UpdateBusinessPage from "./Steps/UpdateBusinessPage";
import PaymentPage from "./Steps/PaymentPage";
import "./wizard.css";
import HttpClient from "../../utils/HttpClient";
import { useSelector } from 'react-redux'

const WizardContainer = ({ step = 1, subscriptionId }) => {
    const [currentStep, setCurrentStep] = useState(step);
    const { UserProfileID } = useSelector((state) => state.app);

    const steps = [
        { id: 1, title: "Contact information" },
        { id: 2, title: "Business Profile" },
        { id: 3, title: "Business page" },
        { id: 4, title: "Payment" },
    ];

    const handleNext = () => setCurrentStep((prev) => Math.min(prev + 1, steps.length));
    const handleBack = () => setCurrentStep((prev) => Math.max(prev - 1, 1));

    const updateSubscriptionDetails = async (data) => {
        await HttpClient.requestData("update-my-page", "POST", data);
    }

    useEffect(() => {
        if (subscriptionId && UserProfileID) {
            const data = {
                subscriptionId: subscriptionId,
                emailId: UserProfileID?.emailId
            }
            updateSubscriptionDetails(data);
        }
    }, [subscriptionId, UserProfileID]);

    return (
        <div className="container py-2">
            <WizardProgressBar steps={steps} currentStep={currentStep} />
            <div className="mt-4">
                {currentStep === 1 && (<ContactInformation onNext={handleNext} subscriptionId={subscriptionId} />)}
                {currentStep === 2 && (<BusinessProfileName onNext={handleNext} onBack={handleBack} />)}
                {currentStep === 3 && (<UpdateBusinessPage onNext={handleNext} onBack={handleBack} />)}
                {currentStep === 4 && (<PaymentPage onBack={handleBack} />)}
            </div>
        </div>
    );
};
export default WizardContainer;
